export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "hide_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скрыть все уведомления"])}
      },
      "en": {
        "hide_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide all notifications"])}
      }
    }
  })
}
